const initialState = {
  isDrawerOpen: false,
  subscribe: {
    form: {
      name: null,
      email: null
    },
    isSubscribeVisible: false
  },
  faqs: [],
  about: {},
  contact: {},
  referralCode: null,
};


const TOOGLE_DRAWER = 'TOGGLE_DRAWER';
const TOGGLE_SUBSCRIBE = 'TOGGLE_SUBSCRIBE';
const CACHE_REFERRAL_CODE = 'CACHE_REFERRAL_CODE';

export const cacheReferralCode = code => ({ type: CACHE_REFERRAL_CODE, payload: code });

export const toggleDrawer = open => ({ type: TOOGLE_DRAWER, payload: open });
export const toggleSubscribe = () => ({type: TOGGLE_SUBSCRIBE});

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CACHE_REFERRAL_CODE:
      return { ...state, referralCode: payload };
    case TOOGLE_DRAWER:
      return { ...state, isDrawerOpen: payload };
    case TOGGLE_SUBSCRIBE:
      return { 
        ...state, 
        subscribe: {
          ...state.subscribe,
          isSubscribeVisible: !state.subscribe.isSubscribeVisible 
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/app.js